const REUSED_PASSWORD_ERROR =
	'A nova senha não pode ser igual a uma das 3 últimas senhas utilizadas.';

export {REUSED_PASSWORD_ERROR};
